module.exports = __webpack_public_path__ + "static/media/Leerdoel3.f279cf36.png";